import React, {useState} from 'react';
import AccountDetails from '../../../stories/components/OnboardingNew/PopUp/AccountDetails/AccountDetails';

import {useSelector, useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {
  NON_EDITABLE_STATUS,
  DOCUMENT_UPLOAD_KYC_URL,
  LOGIN_WITH_MMT_PASSWORD_URL,
  CREATE_PASSWORD_PAGE_URL,
} from '../../../constants';
import useRedirect from '../hooks/useRedirection';
import {sendEvarData} from '@ibibo/analytics';
import * as actions from '../../../store/actions/index';
import {
  tokenSelector,
  errorSelector,
  businessTypeListSelector,
  statusSelector,
  nextLoader,
  gstLoaderSelector,
  userDetailsNewSelector,
  existingUserSelector,
  nextScreenSelector,
  mobileSelector,
} from '../../../store/selectors';
import {getCrid} from '../../../../../myaccount/src/utils/redirectWithCrId';
import {useAnalyticService} from '@ibibo/analytics-provider';
const Details = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {sendTrackingDataToSdk} = useAnalyticService();
  const data = useSelector(userDetailsNewSelector);

  const token = useSelector(tokenSelector);
  const error = useSelector(errorSelector);
  const status = useSelector(statusSelector);
  const businessTypeList = useSelector(businessTypeListSelector);
  const euSelect = useSelector(existingUserSelector);
  const nextScreen = useSelector(nextScreenSelector);
  const mobile = useSelector(mobileSelector);

  // const businessTypeList = {
  //   "em": "Employee",
  //   "hf": "HUF",
  //   "jv": "Joint Venture",
  //   "lt": "Limited",
  //   "pp": "Partnership",
  //   "pt": "Pvt Ltd Company",
  //   "sp": "Sole Proprietership"
  // }

  const setLoader = useSelector(nextLoader);
  const gstLoader = useSelector(gstLoaderSelector);

  const [gstCheck, setGstCheck] = useState(false);
  const [editEmail, setEditEmail] = useState(true);

  const uploadPan = ({panNumber, agencyName, panFile, fullName, successCallBack}) => {
    sendEvarData(
      {
        prop54: 'myPartner|signup|businessVerification|documentUpload|PAN',
      },
      true,
    );
    let fd = new FormData();
    fd.append('agency_name', agencyName);
    fd.append('pan_number', panNumber);
    fd.append('token', token);
    fd.append('document_type', 'pancard');
    fd.append('file', panFile, 'panImage.png');
    fd.append('full_name', fullName);
    dispatch(actions.submitPAN(fd, panNumber, agencyName, successCallBack));
    sendTrackingDataToSdk?.(
      {
        event_detail: {
          event_name: 'click',
          event_type: 'user_action',
          event_value: 'Pan Upload Click',
        },
      },
      'HOME',
    );
  };

  const cancelPan = () => {
    dispatch(actions.resetPANInfo());
  };

  const errorCallBack = () => {
    dispatch(actions.submitKYCModalInfo('updated'));
    setEditEmail(false);
  };

  const successCallback = data => {
    const fbPixel = `<script>!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', '313388378811698');fbq('track', 'myPartner_Lead');</script><noscript><img height="1" width="1" style="display:none"src="https://www.facebook.com/tr?id=313388378811698&ev=PageView&noscript=1"/></noscript>`;
    let tag = document.createElement('script');
    tag.innerHTML = `${fbPixel}`;
    if (data.screen === 'kyc_doc') {
      history.push(`${DOCUMENT_UPLOAD_KYC_URL}?crId=${getCrid()}`);
    } else if (data.screen === 'mmt_password') {
      history.push(`${LOGIN_WITH_MMT_PASSWORD_URL}?crId=${getCrid()}`);
    } else if (data.screen === 'create_password') {
      history.push(`${CREATE_PASSWORD_PAGE_URL}?crId=${getCrid()}`);
    }
    setEditEmail(true);
  };

  const submitInfo = dataObj => {
    // if (NON_EDITABLE_STATUS.indexOf(status) !== -1) {
    //     successCallback();
    //     return;
    // }
    const dataToSubmit = {
      token: token,
      agency_name: dataObj.agencyName,
      pan_number: dataObj.panNumber,
      gstn: dataObj.gstNumber,
      business_type: dataObj.businessType,
      address: dataObj.address,
      state: dataObj.state,
      city: dataObj.city,
      pincode: dataObj.pincode,
      title: dataObj.title,
      full_name: dataObj.fullName,
      email: dataObj.email,
    };

    let fd = new FormData();
    for (var key in dataToSubmit) {
      fd.append(key, dataToSubmit[key]);
    }
    dispatch(actions.submitDetails(fd, dataToSubmit, successCallback, errorCallBack));
  };
  return (
    <AccountDetails
      data={data}
      error={error}
      status={status}
      submitDetails={data => submitInfo(data)}
      onUpload={data => uploadPan(data)}
      cancelPAN={data => cancelPan()}
      businessTypeList={businessTypeList}
      setLoader={setLoader}
      gstLoader={gstLoader}
      mobile={mobile}
      editEmail={editEmail}
    />
  );
};

export default Details;
